import { Select } from "antd";
import { SelectComPesquisa } from "../../../../../SelectComPesquisa";
import Especie from "../../../../../../Models/Financeiro/Conta/Remessa/Especie";
import { useEspecieListar } from "../../../../../../Services/Financeiro/Conta/Remessa/EspecieService";
export interface IEspecieSelectProps extends React.ComponentProps<typeof Select> {
}

export default function EspecieSelect({
    loading,
    placeholder,
    allowClear,
    ...rest
}:IEspecieSelectProps) {
    placeholder = placeholder ?? "Selecione";
    allowClear = allowClear ?? true;
    loading = loading ?? false;

    const {
        data,
        isLoading,
    } = useEspecieListar({
        ativo : true
    });
    return <SelectComPesquisa 
        {...rest}
        placeholder={placeholder}
        allowClear={allowClear}
        loading={isLoading || loading}
        options={data?.data?.map(m => {
            return {
                value : m.codigo,
                label : `${m.sigla} - ${m.nome}`
            }
        })}
    />
}